import { Routes } from '@angular/router';
import {
    ACTION_DETAIL,
    AUTH,
    CAMMS_RISK,
    CAMMS_SERVICE,
    LANDING_PAGE,
    OTHER_APP,
    SUPPORT,
} from '@core/constants';
import { AuthGuard } from '@core/guards/auth.guard';
import { localizationResolver } from '@core/resolvers/localization-resolver';
import { NAVIGATE_HUB } from 'projects/camms-navigate-hub/src/public-api';

export const appRoutes: Routes = [
    {
        path: '',
        loadComponent: () => import('./core/components/app-layout/app-layout.component').then(m => m.AppLayoutComponent),
        children: [
            {
                path: `${AUTH}`,
                loadChildren: () =>
                    import('src/app/core/auth/auth.routes').then((m) => m.authRoutes)
            },
            {
                path: `${CAMMS_RISK}`,
                canActivate: [AuthGuard],
                loadChildren: () => import('./camms-risk/camms-risk.routes').then((m) => m.cammsRiskRoutes),
            },
            {
                path: `${CAMMS_SERVICE}`,
                canActivate: [AuthGuard],
                loadChildren: () =>
                    import('src/app/camms-service/camms-service.routes').then((m) => m.cammsServiceRoutes),
            },
            {
                path: `${LANDING_PAGE}`,
                loadComponent: () => import('./core/components/landing-page/landing-page.component').then(m => m.LandingPageComponent),
            },
            {
                path: `${ACTION_DETAIL}/:actionDetailId`,
                loadComponent: () => import('./camms-risk/features/common-actions/action-detail-tab-view/action-detail-tab-view.component').then(m => m.ActionDetailTabViewComponent),
                data: {
                  localizationModules: [
                    'ACTION_APPROVAL'
                  ]
                },
                resolve: {
                  i18n: localizationResolver
                },
            },
            {
                path: `${OTHER_APP}/:url`,
                loadComponent: () => import('./core/components/other-app/other-app.component').then(m => m.OtherAppComponent),
            },
            {
                path: `${SUPPORT}`,
                loadComponent: () => import('./shared/components/userguide/userguide.component').then(m => m.UserguideComponent),
                canActivate: [AuthGuard],
            },
            {
                path: '',
                redirectTo: `${LANDING_PAGE}`,
                pathMatch: 'full',
            },
            {
                canActivate: [AuthGuard],
                path: `${NAVIGATE_HUB}`,
                loadComponent: () => import('projects/camms-navigate-hub/src/public-api').then(m => m.CammsNavigateHubComponent),
            },
            { path: '**', loadComponent: () => import('./core/components/not-found/not-found.component').then(m => m.NotFoundComponent) },
        ]
    }
    
];